import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef } from 'react';
import { useContextProps, HeadingContext } from 'react-aria-components';
import { PrivateText } from './text.esm.js';

var _excluded = ["as", "variant", "slot", "testId"],
  _excluded2 = ["level"];
var Heading = /*#__PURE__*/forwardRef(function Heading(_ref, ref) {
  var _ref$as = _ref.as,
    element = _ref$as === void 0 ? 'h3' : _ref$as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'heading-16' : _ref$variant,
    _ref$slot = _ref.slot,
    slot = _ref$slot === void 0 ? 'title' : _ref$slot,
    testId = _ref.testId,
    props = _objectWithoutProperties(_ref, _excluded);
  // remove extra unused props from react-aria HeadingContext
  var _useContextProps = useContextProps(_objectSpread2({
    slot: slot
  }, props), ref, HeadingContext);
  var _useContextProps2 = _slicedToArray(_useContextProps, 2);
  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var _props = props;
    _props.level;
    var rest = _objectWithoutProperties(_props, _excluded2);
  return /*#__PURE__*/React__default.createElement(PrivateText, _extends({
    ref: ref,
    as: element,
    variant: variant,
    anchorClassName: "csg-tw-heading",
    slot: slot,
    testId: testId
  }, rest));
});
Heading.displayName = 'Heading';
var Heading$1 = Heading;

export { Heading$1 as default };
//# sourceMappingURL=heading.esm.js.map
